import { createFileRoute, Link } from "@tanstack/react-router";
import { allTutorials } from "content-collections";

export const Route = createFileRoute("/_layout/tutorials/")({
	component: RouteComponent,
	head: () => {
		const tutorialListSchema = {
			"@context": "https://schema.org",
			"@type": "ItemList",
			name: "Macrowave Embed Tutorials",
			description:
				"Step-by-step guides for embedding Macrowave live streams on any platform",
			url: "https://macrowave.co/tutorials",
			itemListElement: allTutorials.map((tutorial, index) => ({
				"@type": "ListItem",
				position: index + 1,
				item: {
					"@type": "HowTo",
					name: tutorial.seoTitle,
					description: tutorial.summary,
					url: `https://macrowave.co/tutorials/${tutorial._meta.path}`,
				},
			})),
		};

		return {
			meta: [
				{
					title: "Embed Macrowave on Any Platform - Tutorials & Guides",
				},
				{
					name: "description",
					content:
						"Learn how to embed Macrowave live streams on WordPress, Wix, Squarespace, Webflow, and more. Easy step-by-step tutorials with copy-paste code examples.",
				},
				{
					property: "og:title",
					content: "Embed Macrowave on Any Platform - Tutorials & Guides",
				},
				{
					property: "og:description",
					content:
						"Learn how to embed Macrowave live streams on WordPress, Wix, Squarespace, Webflow, and more.",
				},
				{
					property: "og:type",
					content: "website",
				},
				{
					property: "og:url",
					content: "https://macrowave.co/tutorials",
				},
			],
			scripts: [
				{
					type: "application/ld+json",
					children: JSON.stringify(tutorialListSchema),
				},
			],
		};
	},
});

function RouteComponent() {
	return (
		<div className="max-w-7xl mx-auto py-16 px-6">
			<h1 className="font-serif-600 text-4xl text-black mb-12">
				Embed Tutorials
			</h1>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
				{allTutorials.map((tutorial) => (
					<Link
						key={tutorial._meta.path}
						to={`/tutorials/${tutorial._meta.path}`}
						className="group block"
					>
						<article className="h-full flex flex-col">
							{tutorial.image && (
								<div className="relative aspect-[16/10] mb-6 overflow-hidden rounded-2xl bg-gray-100">
									<img
										src={tutorial.image}
										alt={tutorial.title}
										loading="lazy"
										className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
									/>
								</div>
							)}
							<div className="flex flex-col flex-grow">
								<div className="flex items-center justify-between mb-3">
									<span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
										{tutorial.platform}
									</span>
									<div className="flex items-center gap-2">
										<span className="font-serif text-xs text-gray-500">
											{tutorial.readingTime} min read
										</span>
									</div>
								</div>
								<h2 className="font-serif-600 text-2xl text-black mb-3 leading-tight group-hover:text-gray-600 transition-colors">
									{tutorial.title}
								</h2>
								<p className="font-serif text-gray-600 leading-relaxed flex-grow">
									{tutorial.summary}
								</p>
							</div>
						</article>
					</Link>
				))}
			</div>
		</div>
	);
}
